import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import PageHeader from '@/components/PageHeader';
import { ErrorBanner } from '@/components/ui';
import { templatesService } from '@/api/services/templates';
import { formatApiError } from '@/utils/formatApiError';

type HistoryItem = {
  id: string;
  templateTitle?: string;
  templateSlug?: string;
  version?: string;
  searchId?: string | null;
  installedAt?: string | null;
};

export default function TemplateHistoryPage() {
  const [items, setItems] = useState<HistoryItem[]>([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    templatesService
      .history()
      .then((r) => setItems(r.items as HistoryItem[]))
      .catch((e) => setError(formatApiError(e, 'Failed to load install history')))
      .finally(() => setLoading(false));
  }, []);

  return (
    <>
      <PageHeader title="Install history" subtitle="Templates installed by your organization">
        <Link to="/templates" className="btn btn-ghost btn-sm">
          Marketplace
        </Link>
      </PageHeader>
      {error ? <ErrorBanner message={error} /> : null}
      {loading ? <p className="muted">Loading…</p> : null}
      {!loading && items.length === 0 ? <p className="muted">No installations yet.</p> : null}
      <div className="table-wrap">
        <table className="admin-table">
          <thead>
            <tr>
              <th>Template</th>
              <th>Version</th>
              <th>Installed</th>
              <th>Search</th>
            </tr>
          </thead>
          <tbody>
            {items.map((item) => (
              <tr key={item.id}>
                <td>{item.templateTitle || item.templateSlug}</td>
                <td>{item.version}</td>
                <td>{item.installedAt ? new Date(item.installedAt).toLocaleString() : '—'}</td>
                <td>
                  {item.searchId ? (
                    <Link to={`/searches/${item.searchId}`}>View search</Link>
                  ) : (
                    '—'
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}
